
import React, {useState} from "react";
import Link from "./Link";
import {TEMPLATE_PAGE_IN_CONSTRUCTION} from "../Views";

function Tabs (props) {
    let content = TEMPLATE_PAGE_IN_CONSTRUCTION;
    const
        currentTabs = props.tabs ? props.tabs : [],

        defaultTabSelected = props.defaultTabSelected ? props.defaultTabSelected : currentTabs.length > 0 && currentTabs[0].attributes["data-key"],

        [tabSelected, setTabSelected] = useState(defaultTabSelected),

        tabs = currentTabs.map((item) => {
            const active = item.attributes["data-key"] && (item.attributes["data-key"] === tabSelected );
            return {
                ...item,
                className: item.className + (active ? " active" : ""), active: active};
        }),

        handleClick = (event) => {
            const selectedTab = event.target.getAttribute("data-key");
            if(props.hasOwnProperty("handleTabSelected") && props.handleTabSelected){
                const continueProcess = props.handleTabSelected(selectedTab, event.target);
                if(continueProcess !== false){
                    setTabSelected(selectedTab);
                }
            }
            else{
                setTabSelected(selectedTab);
            }
        },

        li = tabs.map((item, index) => {
            if(item.active && item.component){
                content = item.component;
            }
            const data = {...item, handleClick: handleClick}
            return <li className="nav-item " role="presentation" key={"li-" + index}>
                <Link data={data} key={"link-" + index} />
            </li>;
        })
    ;
    return <>
        <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">{li}</ul>
        <div className="tab-content" id="pills-tabContent">{content}</div>
    </>
}
export default Tabs;